import { render, staticRenderFns } from "./action-setting.vue?vue&type=template&id=7af48d30&scoped=true"
import script from "./action-setting.vue?vue&type=script&lang=js"
export * from "./action-setting.vue?vue&type=script&lang=js"
import style0 from "./action-setting.vue?vue&type=style&index=0&id=7af48d30&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af48d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af48d30')) {
      api.createRecord('7af48d30', component.options)
    } else {
      api.reload('7af48d30', component.options)
    }
    module.hot.accept("./action-setting.vue?vue&type=template&id=7af48d30&scoped=true", function () {
      api.rerender('7af48d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/hike/action-setting.vue"
export default component.exports